export const LOCALE = process.env.GATSBY_LOCALE || 'de-DE';
